import { Button, Form, Select, message, Radio } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import {
  ServiceMappingConfigPayload,
  getServiceSourceMappings,
  saveServiceMappingConfig,
  MstRequest,
  SourceAppNamelist,
  getSourceAppNames,
  getServiceName,
  ServiceNamelist,
  ModuleNamelist,
  getModuleMaster,
} from 'api/master';
import { FileExcelFilled } from '@ant-design/icons';
//import { Modal } from 'antd';
import ServiceMaplist from '../ServiceMaplist';
import moment from 'moment';
import xlsx from 'json-as-xlsx';

const mstRequest: MstRequest = {};

const Filter = () => {
  const { Option } = Select;

  const [form] = Form.useForm<ServiceMappingConfigPayload>();
  const [filter, setFilter] = useState(mstRequest);
  //const [statusId, setStatusId] = useState(0);
  //const [_sourceId, setSourceId] = useState(0);
  const [sourceAppNames, setSourceAppNames] = useState<SourceAppNamelist[]>([]);
  const [serviceNames, setServiceNames] = useState<ServiceNamelist[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedServiceDescription, setSelectedServiceDescription] = useState<string>('');
  const [selectedModuleDescription, setSelectedModuleDescription] = useState<string>('');
  const [moduleName, setModuleName] = useState<ModuleNamelist[]>([]);

  const isAdmin = sessionStorage.getItem('isAdmin');
  useEffect(() => {
    fetchSourceAppNames();
  }, []);

  const fetchSourceAppNames = async () => {
    try {
      debugger;
      mstRequest.userName = sessionStorage.getItem('user')?.toString();
      mstRequest.isActive = true;
      mstRequest.pageNo = 0;
      mstRequest.pageSize = 0;
      mstRequest.roleId = '';

      const response = await getSourceAppNames(mstRequest);
      setSourceAppNames(response.data);
      const res = await getServiceName(mstRequest);
      setServiceNames(res.data);
      const responseFromModule = await getModuleMaster(mstRequest);
      setModuleName(responseFromModule.data);
    } catch (error) {
      console.error('Error fetching source application names:', error);
    }
  };

  const handleServiceChange = useCallback(
    (value: string) => {
      const selectedService = serviceNames.find((service) => service.code === value);
      if (selectedService) {
        setSelectedServiceDescription(selectedService.description || '');
      } else {
        setSelectedServiceDescription('');
      }
    },
    [serviceNames]
  );

  const handleModuleChange = useCallback(
    (value: string) => {
      const selectedModule = moduleName.find((name) => name.code === value);
      if (selectedModule) {
        setSelectedModuleDescription(selectedModule.description || '');
      } else {
        setSelectedModuleDescription('');
      }
    },
    [moduleName]
  );

  const handleSubmit = useCallback(
    async (values: ServiceMappingConfigPayload) => {
      try {
        debugger;
        values.createdBy = sessionStorage.getItem('user')?.toString();
        values.sourceAppName = '';
        values.createdOn = '';
        await saveServiceMappingConfig(values);
        form.resetFields();
        setFilter({});
        // Modal.success({
        //     title: 'Success',
        //     content: 'Configuration saved successfully.',
        //     onOk: () => window.location.reload(),
        // });
        message.success('Configuration saved successfully.');
        setSelectedServiceDescription('');
        setSelectedModuleDescription('');
        //window.location.reload();
      } catch (error) {
        console.error('Error saving service mapping config:', error);
        message.error('Failed to save service mapping config');
      }
    },
    [form]
  );

  // function handleDownload(_e: any) {
  //   debugger;
  //   filter.pageNo = -1;
  //   getServiceSourceMappings(filter).then((_x) => {
  //     const csvConfig = {
  //       useKeysAsHeaders: true,
  //       filename: 'ServiceMapping-Report.csv',
  //     };
  //     const csvData = generateCsv(csvConfig)(_x.data.data);
  //     download(csvConfig)(csvData);
  //   });
  // }
  function getFullDate(date: string, format = 'DD/MM/YYYY HH:mm:ss') {
    if (date != null) {
      const dateMoment = moment(new Date(date)).format(format);
      return dateMoment;
    }
  }

  function handleDownload(_e: any) {
    filter.pageNo = -1;
    filter.isExtract = true;
    // console.log('download filter ', filter);

    getServiceSourceMappings(filter).then((_x) => {
      console.log('service source mapping ', _x);
      let settings = {
        fileName: 'ServiceMapping-Report',
        extraLength: 3,
        writeMode: 'writeFile',
        writeOptions: {},
        RTL: false,
      };

      const sortedData =
        _x.data?.data.sort((a: any, b: any) => {
          return b.id - a.id;
        }) || [];
      const updatedData = sortedData.map((item: any, index) => ({
        ...item,
        createdOn: getFullDate(item.createdOn),
        ROWNUM: index + 1,
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'id', value: 'id' },
            { label: 'Source Id', value: 'sourceId' },
            { label: 'Service Code', value: 'serviceCode' },
            { label: 'Flag', value: 'flag' },
            { label: 'Created On', value: 'createdOn' },
            { label: 'Created By', value: 'createdBy' },
            { label: 'Service Value', value: 'serviceValue' },
            { label: 'Source Application Name', value: 'sourceAppName' },
            { label: 'Module Name', value: 'moduleName' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = mstRequest;
    setFilter(updatedFilter);
    setSelectedServiceDescription('');
    setSelectedModuleDescription('');
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Email/SMS Service Mapping</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<ServiceMappingConfigPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    ['sourceAppName']:
                      isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div>
                        <Form.Item label={'Source Application Name:'}></Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          //label={'Source Application Name:'}
                          name="sourceId"
                          className="fieldTitle"
                          rules={[
                            { required: true, message: 'Please select source application name.' },
                          ]}
                        >
                          <Select placeholder="Select" size="large">
                            {sourceAppNames.map((app) => (
                              <Option key={app.sourceId} value={app.sourceId}>
                                {app.sourceApplicationName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div>
                        <Form.Item label={'Module Name :'}></Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          //label={'Source Application Name:'}
                          name="moduleName"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please select module name.' }]}
                        >
                          <Select placeholder="Select" size="large" onChange={handleModuleChange}>
                            {moduleName.map((app) => (
                              <Option key={app.id} value={app.code}>
                                {app.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {selectedModuleDescription && (
                          <span style={{ color: 'red' }}>{selectedModuleDescription}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div>
                        <Form.Item label={'Service Name:'}></Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          //label={'Service Name:'}
                          name="serviceCode"
                          className="fieldTitle"
                          rules={[{ required: true, message: 'Please select service name.' }]}
                        >
                          <Select placeholder="Select" size="large" onChange={handleServiceChange}>
                            {serviceNames.map((app) => (
                              <Option key={app.code} value={app.code}>
                                {app.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {selectedServiceDescription && (
                          <span style={{ color: 'red' }}>{selectedServiceDescription}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div>
                        <Form.Item label={'Active/InActive:'}></Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={''} name="flag" className="fieldTitle" initialValue={1}>
                          <Radio.Group>
                            <label
                              className="btn btn-primary col-md-2"
                              style={{ marginRight: '10px', marginBottom: '20px' }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="appType"
                                name="flag"
                                type="radio"
                                value={1}
                                style={{ width: '600px', color: 'white', fontWeight: '' }}
                              >
                                {' '}
                                Active
                              </Radio>
                            </label>
                            <label
                              className="btn btn-primary col-md-2"
                              style={{ marginRight: '10px', marginBottom: '20px' }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="appType"
                                name="flag"
                                type="radio"
                                value={0}
                                style={{ width: '300px', color: 'white' }}
                              >
                                InActive
                              </Radio>
                            </label>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="payment-button">
                      <Button
                        id="btnClear"
                        className="proceed-btn"
                        size="small"
                        style={{ height: '40px', width: '100px', marginBottom: '10px' }}
                        onClick={handleReset}
                      >
                        CLEAR
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        id="btnSave"
                        className="proceed-btn"
                        size="small"
                        style={{ height: '40px', width: '100px', marginBottom: '10px' }}
                        onClick={() => form.submit()}
                      >
                        SAVE
                      </Button>
                      <Button
                        type="link"
                        icon={<FileExcelFilled />}
                        style={{ float: 'right', fontSize: '30px', color: 'green' }}
                        onClick={handleDownload}
                      ></Button>
                    </div>
                  </div>
                </Form>
              </div>
              <ServiceMaplist filter={{ ...filter }} onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
